// Utility for dynamic text scaling and truncation
export function fitText({
  text,
  maxFontSize = 28,
  minFontSize = 14,
  maxWidth = 180,
  maxLength = 18,
  fontScale = 0.6,
  ellipsis = '…',
}) {
  if (!text) return { display: '', fontSize: minFontSize };
  let display = text;
  let fontSize = Math.max(
    minFontSize,
    Math.min(maxFontSize, maxWidth / (text.length * fontScale))
  );
  if (text.length > maxLength) {
    display = text.slice(0, maxLength - 1) + ellipsis;
    fontSize = minFontSize;
  }
  return { display, fontSize };
}
